import React, {Component} from 'react';
import {connect} from 'react-redux';

import {schoolActions, schoolSelectors} from "../../store/school";
import {authActions, authSelectors} from "../../store/auth";
import {layoutActions} from "../../store/layout";
import {Box} from 'rebass'
import {GlobalStyle} from "../../theme";
import {Normalize} from 'styled-normalize'

import Chatpopup from '../ChatPopup';
import PropTypes from "prop-types";

class Layout extends Component {
	constructor(props) {
		super(props);

		this.state = {
			width: 0,
			height: 0,

		};
		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
	}

	componentDidMount() {
		this.updateWindowDimensions();

		this.handleUpdateHeader(this.props);
		window.addEventListener('resize', this.updateWindowDimensions);

	}

	componentWillReceiveProps(nextProps) {
		if(nextProps.calendar && nextProps.roster !== this.props.roster){
			this.handleUpdateHeader(nextProps);
		} else if(!nextProps.calendar) {
			this.handleUpdateHeader(nextProps);
		}
	}

	handleUpdateHeader = (props) => {
		const { updateHeaderProps, noFooter, noHeader, noSideBar, rosterDetails, type, details, isFaculty, profile, bg, roster } = props;
		updateHeaderProps({ noFooter, noSideBar, noHeader, rosterDetails, type, details, isFaculty, profile, bg, roster});
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
		// this.listener()
	}

	updateWindowDimensions = () => {
		this.setState({width: window.innerWidth, height: window.innerHeight});
	}

	// shouldComponentUpdate(nextProps, nextState, nextContext) {
	// 	const { updateProfileInfo, updateSchoolInfo, loadingProfile} = this.props;
	//
	// 	if(nextProps.profile !== this.props.profile){
	// 		updateProfileInfo(nextProps.profile)
	// 	}
	// 	if(nextProps.school !== this.props.school){
	// 		updateSchoolInfo(nextProps.school)
	// 	}
	// 	return true
	// }

	// componentWillReceiveProps(nextProps, nextContext) {
	// 	const { updateHeaderProps} = this.props;
	//
	// 	if(nextProps !== this.props){
	// 		updateHeaderProps(this.props)
	// 	}
	//
	//
	// }

	updateSchoolAndProfile = (profile, school) => {
		const { updateProfileInfo, updateSchoolInfo} = this.props;
		updateProfileInfo(profile);
		updateSchoolInfo(school)
	}

	render() {
		const {children, withTabs, school, profile, loadingProfile} = this.props;

		if (profile !== null && profile !== undefined && school !== null && school !== undefined) {
			if (loadingProfile === true) {
				this.updateSchoolAndProfile(profile, school)
			}
		}
		return (
			<div>
				<Normalize/>
				<GlobalStyle/>
				{withTabs ?
					<Box mt={[40, 0]}>
						{children}
					</Box> :
					<Box p={0} ml={0} mt={[30, 0]} pt={[30, 0]} mb={[50, 0]}>
						{children}
					</Box>
				}
				<Chatpopup {...this.props}/>
			</div>
		);
	}
}

Layout.propTypes = {
	noSideBar: PropTypes.bool,
	noFooter: PropTypes.bool,
	rosterDetails: PropTypes.bool,
	type: PropTypes.string,
	isFaculty: PropTypes.bool,
	profile: PropTypes.object,
	bg: PropTypes.string,
};

Layout.defaultProps = {
	noSideBar: false,
	noFooter: false,
	rosterDetails: false,
	type: '',
	bg: 'white',
	roster: null
};

const mapStateToProps = (state) => ({
	schoolInfo: schoolSelectors.refreshSchool(state.school),
	profileInfo: authSelectors.refreshProfile(state.auth),
	loadingProfile: authSelectors.isLoading(state.auth)

});

const mapDispatchToProps = (dispatch) => ({
	updateSchoolInfo: (data) => {
		dispatch(schoolActions.updateSchoolInfo(data))
	},
	updateProfileInfo: (data) => {
		dispatch(authActions.updateProfileInfo(data))
	},
	updateHeaderProps: (data) => {
		dispatch(layoutActions.updateHeaderProps(data))
	}
});


export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Layout);
